export default (margin, precision) => (item) => ({
  quote: item.itemId,
  supplier: item.associated.supplier,
  item: item.associated.itemId,
  price: item.associated.price,
  isPriceGuaranted: !!item.associated.isPriceGuaranted,
  proposalPrice: (item.associated.price * ((margin / 100) + 1)).toFixed(precision),
  minimumPrice: (item.associated.price * ((margin / 100) + 1)).toFixed(precision)
})



// WEBPACK FOOTER //
// ./src/view/item-pricing/helpers/MapToChoice.js